<div class="page">
  <div class="header">
    <h1 class="header-title">
      @if (driverId) {
        <button class="schedule-back" mat-icon-button aria-label="Terug" [routerLink]="['/schedule', type, driverId]">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <mat-icon>person</mat-icon>
      <span>{{ driverId === userId ? 'Mijn rooster' : 'Rooster' }}</span>
    </h1>
  </div>
  @if (!loading()) {
    <div class="content-card">
      <div class="title-wrapper">
        <h2 class="title">
          Mijn ritten
          @if (
            (daypartDay?.driverId !== userId && type === 'driver') ||
            (daypartDay?.coDriverId !== userId && type === 'co-driver')
          ) {
            <span>({{ driver?.name }})</span>
          }
          op {{ moment(daypartDay?.start).format('dddd DD MMMM YYYY') }} van
          {{ moment(daypartDay?.start).format('HH:mm') }} tot
          {{ moment(daypartDay?.end).format('HH:mm') }}
        </h2>
      </div>
      <div class="wrapper">
        <div class="legend-wrapper">
          <span>Legenda:</span>
          <div class="legend-item">
            <div class="legend-color upcoming"></div>
            <p class="legend-title">Volgende rit</p>
          </div>
          <div class="legend-item">
            <div class="legend-color belongs-to-day-part"></div>
            <p class="legend-title">Valt binnen dagdeel</p>
          </div>
          <div class="legend-item">
            <div class="legend-color finished"></div>
            <p class="legend-title">Klaar</p>
          </div>
        </div>
        <div class="ride-item-wrapper">
          @for (ride of rides(); track ride.id) {
            <app-event-item
              [ride]="ride"
              [vehicle]="vehicle!"
              [driver]="getDriver(ride.driverId ?? '')"
              [cssClasses]="
                'no-click no-vehicle-color ' +
                (ride.upcoming ? 'upcoming ' : '') +
                (ride.belongsToDaypart ? 'belongs-to-day-part ' : '') +
                (ride.finished ? 'finished ' : '')
              "
              [type]="'driver'"
            ></app-event-item>
          }
        </div>
        @if (rides()?.length == 0 && loading() === false) {
          <p>Je bent nog nergens voor ingepland</p>
        }
        @if (rides()?.length == 0 && loading() === true) {
          <p>We zijn bezig met de het rooster updaten</p>
        }
      </div>
    </div>
  }
</div>
